import api from './api';
import axios from 'axios';
import { getJwt } from '@app/helpers';

export const baixarModeloOrganogramaGestores = async () => {
  const resposta = await axios.get('/api/organogramaGestores/modelo-importacao', {
    responseType: 'blob',
    headers: { Authorization: `Bearer ${getJwt()}` },
  });
  const url = URL.createObjectURL(resposta.data);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'ModeloOrganogramaGestores.xlsx';
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export interface OrganogramaGestor {
  id: string;
  usuarioId: string;
  gestor: string;
  userName?: string;
  email?: string;
  cargo?: string;
  diretoriaId: string;
  diretoria: string;
  siglaDiretoria?: string;
  areaId?: string;
  area?: string;
  siglaArea?: string;
  departamentoId?: string;
  departamento?: string;
  siglaDepartamento?: string;
}

export const getAllOrganogramaGestores = () => api.get<OrganogramaGestor[]>('organogramaGestores');
export const createOrganogramaGestor = (item: OrganogramaGestor) => api.post<any>('organogramaGestores', item);
export const updateOrganogramaGestor = (item: OrganogramaGestor) =>
  api.put<any>(`organogramaGestores/${item.id}`, item);
export const deleteOrganogramaGestor = (id: string) => api.delete<any>(`organogramaGestores/${id}`);

export interface ImportacaoOrganogramaResult {
  valid: boolean;
  importado: boolean;
  novos: number;
  atualizados: number;
  semAlteracao: number;
  notifications: { message: string }[];
}

export const importarOrganogramaGestores = (file: File, confirmar: boolean) => {
  const data = new FormData();
  data.append('file', file);
  data.append('confirmar', confirmar.toString());
  return api.post<ImportacaoOrganogramaResult>('organogramaGestores/importar', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
